import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-renew-contract',
  templateUrl: './renew-contract.component.html',
  styleUrls: ['./renew-contract.component.scss'],
})
export class RenewContractComponent implements OnInit {
  form: FormGroup;
  minExpiryDate = new Date();
  minAffectiveDate = new Date();

  @Output() cancel = new EventEmitter();
  @Output() submit = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      affectiveDate: new FormControl(null, Validators.required),
      expiryDate: new FormControl(null, Validators.required),
    });
  }

  onAffectiveDateChange(event) {
    this.minExpiryDate = new Date(event);
    this.minExpiryDate.setDate(this.minExpiryDate.getDate() + 1);
    if (this.form.value['expiryDate'] && !(new Date(this.form.value['affectiveDate']) < new Date(this.form.value['expiryDate'])))
      this.form.controls.expiryDate.setValue(this.minExpiryDate);
  }

  onCancelClicked() {
    this.cancel.emit();
    this.form.reset();
  }

  onConfirmClicked() {
    this.submit.emit(this.form.value);
    this.form.reset();
  }
}
